import { createAction } from "redux-actions";

export const SWITCH_THEME_ACTION = "SWITCH_THEME_ACTION";
export const FILE_UPLOAD_PROGRESS = "FILE_UPLOAD_PROGRESS";

export const switchThemeAction = createAction(SWITCH_THEME_ACTION);
